import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Card, ToggleButtonGroup, ToggleButton, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { FaCheck } from "react-icons/fa6";
import LandingDivider from "../../common/Dividers/LandingDivider";
import ComingSoon from "./ComingSoon";

function Pricing() {
  const [billingType, setBillingType] = useState("Mensual");
  const [visibleFormId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showTables, setShowTables] = useState(false);
  const [loadedForms, setLoadedForms] = useState(new Set());

  useEffect(() => {
    if (visibleFormId) {
      if (!loadedForms.has(visibleFormId)) {
        if (window.hbspt) {
          window.hbspt.forms.create({
            portalId: "145322866",
            formId:
              visibleFormId === "form1"
                ? "7dcf47ab-0f21-4c65-bc0a-adb46d5b5ff7"
                : visibleFormId === "form2"
                ? "5264877b-a906-48cf-a691-33096fe7d9b2"
                : visibleFormId === "form3"
                ? "fa4273be-d5cc-4ba1-8bec-4f76a8cf1883"
                : null,
            target: `#hubspotForm-${visibleFormId}`,
          });
          setLoadedForms((prev) => new Set(prev).add(visibleFormId));
        }
      }
    }
    const fixedModal = document.querySelector('.fixedModal');
    if (fixedModal) {
      fixedModal.style.display = showModal ? 'block' : 'none';
    }
  }, [showModal, visibleFormId, loadedForms]);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {props.text}
    </Tooltip>
  );

  const pricingPlans = [
    {
      id: 1,
      title: "Plan Base",
      monthlyOriginalPrice: "39 €/mes",
      monthlyPrice: "30 €/mes",
      annualOriginalPrice: "390 €/año",
      annualPrice: "300 €/año",
      discount: "¡23% de Descuento!",
      summary: "Ideal para psicoterapeutas que buscan una solución completa y accesible para comenzar a desarrollarse personalmente.",
      description: (
        <ul>
          <li>
            <OverlayTrigger placement="top" overlay={renderTooltip({ text: "Gestión de perfil con toda la información relevante y necesaria para mostrar cómo puedes ayudar" })}>
              <span>Perfil Profesional Completo <AiOutlineInfoCircle /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderTooltip({ text: "Emparejamiento con pacientes afines. " })}>
              <span>Aparición en Resultados <AiOutlineInfoCircle /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderTooltip({ text: "Interacción confidencial a través de sistema de mensajería interno" })}>
              <span>Comunicación privada con Pacientes <AiOutlineInfoCircle /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderTooltip({ text: "Organiza y gestiona citas directamente. Los pacientes podrán reservar citas" })}>
              <span>Agenda de citas <AiOutlineInfoCircle /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderTooltip({ text: "Accede al informe generado tras el cribado del paciente." })}>
              <span>Valoración previa de pacientes <AiOutlineInfoCircle /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger
              placement="top"
              overlay={renderTooltip({ text: "Utiliza la IA de Psyder para ordenar la información de tus casos, explorar hipótesis clínicas, preparar sesiones, identificar aspectos relevantes y generar resúmenes de trabajo." })}
            >
              <span>Asistente de orientación de casos (10 casos/mes) <AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderTooltip({ text: "Plantea cualquier caso del que quieras recibir ayuda o asesoramiento con un especialista en el tema" })}>
              <span>Revisión de casos con especialistas por mensajería (1 caso/mes) <AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderTooltip({ text: "De entre todos los Grupos, podrás formar parte de 1 en el que compartir conocimiento con más profesionales, recibir feedback, y más" })}>
              <span>Acceso a 1 grupo de trabajo <AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderTooltip({ text: "Materiales gratuitos que poder utilizar en las terapias y opción de adquirir formación continua a precios asequibles." })}>
              <span>Formaciones con descuento <AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderTooltip({ text: "Posibilidad de compartir artículos previa revisión" })}>
              <span>Publicaciones en el Blog de Psyder <AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
        </ul>
      ),
    },
    {
      id: 2,
      title: "Plan Estándar",
      monthlyOriginalPrice: "59 €/mes",
      monthlyPrice: "49 €/mes",
      annualOriginalPrice: "590 €/año",
      annualPrice: "490 €/año",
      discount: "¡17% de Descuento!",
      summary: "Diseñado para profesionales que buscan más recursos, formación y revisión de casos.",
      description: (
        <ul>
          <li>Todo lo Incluido en el Plan Base</li>
          <li>
            <OverlayTrigger
              placement="top"
              overlay={renderTooltip({ text: "Utiliza la IA de Psyder para ordenar la información de tus casos, explorar hipótesis clínicas, preparar sesiones, identificar aspectos relevantes y generar resúmenes de trabajo." })}
            >
              <span>Asistente de orientación de casos (30 casos/mes) <AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderTooltip({ text: "Plantea cualquier caso del que quieras recibir ayuda o asesoramiento con un especialista en el tema. " })}>
              <span>Revisión de casos con especialista por mensajería (2/mes) <AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderTooltip({ text: "Plantea cualquier caso del que quieras recibir ayuda o asesoramiento con un especialista en el tema. " })}>
              <span>Revisión de casos especialista por videollamada (1/mes)<AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderTooltip({ text: "Asesoría personalizada para ayudarte en tu desarrollo profesional. " })}>
              <span>Asesoramiento profesional individualizado por videollamada (1/trimestre) <AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderTooltip({ text: "De entre todos los Grupos, podrás formar parte de 1 en el que compartir conocimiento con más profesionales, recibir feedback, y más" })}>
              <span>Acceso a 3 grupos de trabajo <AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger placement="top" overlay={renderTooltip({ text: "Se están preparando más herramientas y recursos con los que seguir mejorando y podrás tener acceso a ellas a precios muy asequibles." })}>
              <span>Formaciones avanzadas con descuento <AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
        </ul>
      ),
    },
    {
      id: 3,
      title: "Plan Premium",
      monthlyOriginalPrice: "119 €/mes",
      monthlyPrice: "89 €/mes",
      annualOriginalPrice: "1190 €/año",
      annualPrice: "890 €/año",
      discount: "¡25% de Descuento!",
      summary: "Para psicoterapeutas que buscan una experiencia completa.",
      description: (
        <ul>
          <li>Todo lo Incluido en los Planes Base y Estándar</li>
          <li>
            <OverlayTrigger
              placement="top"
              overlay={renderTooltip({ text: "Utiliza la IA de Psyder para ordenar la información de tus casos, explorar hipótesis clínicas, preparar sesiones, identificar aspectos relevantes y generar resúmenes de trabajo." })}
            >
              <span>Asistente de orientación de casos (60 casos/mes)<AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger
              placement="top"
              overlay={renderTooltip({ text: "Plantea cualquier caso del que quieras recibir ayuda o asesoramiento con un especialista en el tema. " })}
            >
              <span>Revisión de casos con especialista por mensajería (4/mes)<AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger
              placement="top"
              overlay={renderTooltip({ text: "Plantea cualquier caso del que quieras recibir ayuda o asesoramiento con un especialista en el tema. " })}
            >
              <span>Revisión de casos con especialista por videollamada (2/mes)<AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger
              placement="top"
              overlay={renderTooltip({ text: "Asesoría personalizada para ayudarte en tu desarrollo profesional. " })}
            >
              <span>Asesoramiento profesional individualizado por videollamada (1/mes)<AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger
              placement="top"
              overlay={renderTooltip({ text: "De entre todos los Grupos, podrás formar parte de 1 en el que compartir conocimiento con más profesionales, recibir feedback, y más. " })}
            >
              <span>Acceso a todos los grupos de trabajo <AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
          <li>
            <OverlayTrigger
              placement="top"
              overlay={renderTooltip({ text: "Materiales gratuitos que poder utilizar en las terapias y opción de adquirir formación continua a precios asequibles. " })}
            >
              <span>Acceso completo a formaciones sin coste adicional <AiOutlineInfoCircle /> <ComingSoon /></span>
            </OverlayTrigger>
          </li>
        </ul>
      ),
    },
  ];

  return (
    <Container>
      <Row className="section-title">
        <Col>
          <h2>Únete a la Evolución de la Psicoterapia con Psyder</h2>
          <h3>
            Regístrate Ahora y Aprovecha la <span className="prim-color">Oferta Pre-Lanzamiento Para Siempre</span>. Inscríbete y disfruta de una <span className="prim-color">Prueba Gratuita</span> de
            7 días desde el momento del Lanzamiento.
          </h3>
        </Col>
      </Row>
      <Row className="section-content justify-content-center">
        <Col md={5}>
          <Row>
            <Col className="d-flex align-items-end justify-content-end">
              <p className="prim-color mb-0">¡Ahorra 2 meses!</p>
            </Col>
          </Row>
          <ToggleButtonGroup type="radio" name="billingOptions" value={billingType} onChange={(value) => setBillingType(value)} className="pricing-toggle w-100 border rounded-pill">
            <ToggleButton id="tbg-radio-1" value="Mensual" className={`pricing-toggle font-button fw-bold w-50 border-0 rounded-pill ${billingType === "Mensual" ? "active" : ""}`}>
              Mensual
            </ToggleButton>
            <ToggleButton id="tbg-radio-2" value="Anual" className={`pricing-toggle font-button fw-bold w-50 border-0 rounded-pill ${billingType === "Anual" ? "active" : ""}`}>
              Anual
            </ToggleButton>
          </ToggleButtonGroup>
        </Col>
      </Row>
      <Row className="section-content">
        {pricingPlans.map((plan) => (
          <Col key={plan.id} lg={4} md={6} className="mb-4" data-aos="fade-up" data-aos-delay={plan.id*100}>
            <Card className="pricing-card h-100">
              <Card.Body className="text-center">
                <h4 className="mb-4">{plan.title}</h4>
                <Card.Text>
                  {billingType === "Mensual" ? (
                    <>
                      <del>{plan.monthlyOriginalPrice}</del>
                      <span className="prim-color d-block fw-bold">{plan.monthlyPrice}</span>
                    </>
                  ) : (
                    <>
                      <del>{plan.annualOriginalPrice}</del>
                      <span className="prim-color d-block fw-bold">{plan.annualPrice}</span>
                    </>
                  )}
                </Card.Text>
                <span className="third-color fw-bold d-block my-2">{plan.discount}</span>
                <p className="my-4" style={{ minHeight: '100px' }}>{plan.summary}</p>
                <Button href="https://psyder.xyz/api/entry-page/join-as-therapist" className="btn-prim my-3 font-button">
                  Únete Ahora
                </Button>
                <div className="mt-4 text-start">{plan.description}</div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      <Row className="text-center">
        <Col>
          <Button className="btn btn-prim mt-3 mb-3 font-button" onClick={() => setShowTables(prev => !prev)}>
            Compara todos los planes y no te pierdas nada
          </Button>
        </Col>
      </Row>
      <div className={`pricing-comparison-wrapper ${showTables ? 'show' : 'hide'}`}>
        <Row className="pricingComparison">
          <Col key={1} lg={6} sm={1} className="mb-4">
            <div className="title-plan-comparison hide-content">Características</div>
            <div className="h-100 card list-features">
              <div>Perfil Profesional Completo</div>
              <div>Aparición en Resultados</div>
              <div>Comunicación privada con Pacientes</div>
              <div>Agenda de Citas</div>
              <div>Valoración previa de pacientes</div>
              <div>Asistente de orientación de casos</div>
              <div>Revisión de casos con especialista por mensajería</div>
              <div>Revisión de casos con especialista por videollamada</div>
              <div>Asesoramiento profesional individualizado por videollamada</div>
              <div>Grupos de Trabajo</div>
              <div>Publicaciones en el Blog</div>
              <div>Formación Básica</div>
              <div>Formación Avanzada</div>
            </div>
            <div className="price-plan-comparison hide-content">
              Precios
            </div>
          </Col>
          <Col key={2} lg={2} sm={1} className="mb-4">
            <div className="title-plan-comparison">Base</div>
            <div className="h-100 card list-features text-center">
              <div><FaCheck /></div>
              <div><FaCheck /></div>
              <div><FaCheck /></div>
              <div><FaCheck /></div>
              <div><FaCheck /></div>
              <div>10 casos/mes</div>
              <div>1/mes</div>
              <div className="x-feature">x</div>
              <div className="x-feature">x</div>
              <div>1</div>
              <div><FaCheck /></div>
              <div>Descuento 30%</div>
              <div className="x-feature">x</div>
            </div>
            <div className="price-plan-comparison">
              <div className="strike-text">{billingType === "Mensual" ? "39 €/mes" : "390 €/año"}</div>
              <div className="bigger-text">{billingType === "Mensual" ? "30 €/mes" : "300 €/año"}</div>
            </div>
          </Col>
          <Col key={3} lg={2} sm={1} className="mb-4">
            <div className="title-plan-comparison">Estándar</div>
            <div className="h-100 card list-features text-center">
              <div><FaCheck /></div>
              <div><FaCheck /></div>
              <div><FaCheck /></div>
              <div><FaCheck /></div>
              <div><FaCheck /></div>
              <div>30 casos/mes</div>
              <div>2/mes</div>
              <div>1/mes</div>
              <div>1/trimestre</div>
              <div>3</div>
              <div><FaCheck /></div>
              <div>Todo incluido</div>
              <div>Descuento 40%</div>
            </div>
            <div className="price-plan-comparison">
              <div className="strike-text">{billingType === "Mensual" ? "59 €/mes" : "590 €/año"}</div>
              <div className="bigger-text">{billingType === "Mensual" ? "49 €/mes" : "490 €/año"}</div>
            </div>
          </Col>
          <Col key={4} lg={2} sm={1} className="mb-4">
            <div className="title-plan-comparison">Premium</div>
            <div className="h-100 card list-features text-center">
              <div><FaCheck /></div>
              <div><FaCheck /></div>
              <div><FaCheck /></div>
              <div><FaCheck /></div>
              <div><FaCheck /></div>
              <div>60 casos/mes</div>
              <div>4/mes</div>
              <div>2/mes</div>
              <div>1/mes</div>
              <div>Todos</div>
              <div><FaCheck /></div>
              <div>Todo incluido</div>
              <div>Todo incluido</div>
            </div>
            <div className="price-plan-comparison">
              <div className="strike-text">{billingType === "Mensual" ? "119 €/mes" : "1190 €/año"}</div>
              <div className="bigger-text">{billingType === "Mensual" ? "89 €/mes" : "890 €/año"}</div>
            </div>
          </Col>
        </Row>
      </div>
      <LandingDivider />
      <Row className="justify-content-center">
        <Col lg={8} className="text-center" style={{ marginTop: 60 }}>
          <p>
            Psyder está <strong>a punto de lanzarse</strong> y estamos preparando <strong>todo para ti</strong>. Cada plan está diseñado para ofrecerte <strong>flexibilidad</strong> y los{" "}
            <strong>recursos</strong> que necesites, tanto si estás comenzando como si ya tienes una carrera consolidada. Disfruta de <strong>soporte</strong> continuo, <strong>conexiones</strong>{" "}
            significativas y oportunidades de <strong>crecimiento profesional</strong>, todo en un solo lugar.
          </p>
        </Col>
      </Row>

      <div className="fixedModal">
          <div className="closeModalBtn" onClick={() => setShowModal(false)}>X</div>
          <div>
            <div
              id="hubspotForm-form1"
              className={`hubspotForm ${visibleFormId === "form1" ? "" : "hidden"}`}
            ></div>
            <div
              id="hubspotForm-form2"
              className={`hubspotForm ${visibleFormId === "form2" ? "" : "hidden"}`}
            ></div>
            <div
              id="hubspotForm-form3"
              className={`hubspotForm ${visibleFormId === "form3" ? "" : "hidden"}`}
            ></div>
          </div>
      </div>

    </Container>
  );
}

export default Pricing;
